<div
  *ngIf="!fromStandAlonePage"
  class="profile-selector-smart-backdrop"
  (click)="onClose()"
></div>
<div
  #profileModal
  [ngClass]="{ advisorBanner: advisorBanner }"
  class="profile-selector-smart"
  id="profile-selector-smart"
  tabindex="0"
  (keydown.escape)="onClose()"
>
  <ng-container *ngIf="profileSelectorFacadeService as profile">
    <idp-profile-selector-ui
      *ngIf="profile.profileDetails$ | async"
      [profileDetails]="
        (profile.profileDetails$ | async) || emptyContentDetails
      "
      [displayTermsOfUse]="(profile.displayTermsUse$ | async) || false"
      [personalStateSelected]="
        (profile.personalSelectedState$ | async) || false
      "
      [businessStateSelected]="
        (profile.businessSelectedState$ | async) || emptyBusinessStateSelected
      "
      [fromStandAlonePage]="fromStandAlonePage"
      (emitBusinessProfile)="selectAccount($event)"
      (emitPersonalProfile)="selectAccount($event)"
      (toggle)="onClose()"
      (logout)="onClickLogout()"
    ></idp-profile-selector-ui>
  </ng-container>
</div>

<form
  #loginPickerRedirectForm
  class="hiddenForm"
  method="POST"
  [action]="refreshURL"
>
  <div *ngFor="let key of queryParamKeys">
    <input
      *ngIf="paramsToIgnore.indexOf(key) === -1"
      type="hidden"
      [name]="key"
      [value]="queryParams[key]"
    />
  </div>
  <button type="submit"></button>
</form>
